// extracted by mini-css-extract-plugin
export default {"Column":"MainGrid_Column__ittz0","Row":"MainGrid_Row__79u+T","MessageOnly":"MainGrid_MessageOnly__uFsiG","ScrollContainer":"MainGrid_ScrollContainer__Zmmm7"};